import PaymentBreakdown from "components/CustomStrategyV2/PaymentBreakdown";
import WeeklyPaymentTimeline from "components/CustomStrategyV2/WeeklyPaymentTimeline";
import { LedgerDto } from "dtos/ledger.dto";
import { PaymentTable, PaymentType, StrategyConfigV2, StrategyResponse } from "dtos/strategy.dto";
import { Section } from "./Partials";
import { OverviewSection } from "./Overview";
import { LedgerTable } from "./Ledger";
import { Button, Skeleton } from "antd";
import { useState } from "react";

export const StrategyPreview = ({
  config,
  strategy,
  paymentTable,
  ledgerEntries,
  bordered,
  loading,
}: Partial<{
  config: StrategyConfigV2;
  strategy: StrategyResponse;
  paymentTable: PaymentTable;
  ledgerEntries: LedgerDto[];
  bordered: boolean;
  loading: boolean;
}>) => {
  const [paymentTableShowMode, setPaymentTableShowMode] = useState<"detailed" | "compact">("compact");
  const isOneTime = (ledgerEntries?.length ?? 0) < 2;

  return (
    <div
      className={`col-span-6 gap-4 h-fit px-3 ${bordered && "border border-solid border-gray-200 rounded-md shadow"}`}
    >
      <Section title="Overview">
        <OverviewSection
          loading={loading}
          strategy={strategy}
          placement={[
            ["total_payment", "total_debt", "total_interest"],
            ["initial_payment", "tenure", "interest_tenure"],
          ]}
        />
      </Section>
      <Section bordered="bottom" title="Payment Breakdown">
        {loading ? (
          <Skeleton.Node active style={{ width: "100%", height: 120 }}>
            {" "}
          </Skeleton.Node>
        ) : (
          <PaymentBreakdown
            total={paymentTable?.totals.payment}
            commission={paymentTable?.totals.program_fee ?? 0}
            creditor={paymentTable?.totals.creditor ?? 0}
            service={paymentTable?.totals.service_fee ?? 0}
            legal={paymentTable?.totals.legal_fee ?? 0}
          />
        )}
      </Section>
      {(loading || !isOneTime) && (
        <Section bordered="bottom" title="Weekly Payment Timeline">
          {loading ? (
            <Skeleton.Node active style={{ width: "100%", height: 160 }}>
              {" "}
            </Skeleton.Node>
          ) : (
            <WeeklyPaymentTimeline
              ledgerEntries={ledgerEntries ?? []}
              initial_weeks={strategy?.common.initial_split ?? 1}
              program_weeks={strategy?.program_tenure}
            />
          )}
        </Section>
      )}
      {!isOneTime && (
        <Section
          bordered="bottom"
          title="Payment Ledger"
          extra={
            <Button
              size="small"
              disabled={loading}
              onClick={() => setPaymentTableShowMode((prev) => (prev === "compact" ? "detailed" : "compact"))}
            >
              {paymentTableShowMode === "detailed" ? "Compact" : "Detailed"}
            </Button>
          }
        >
          <LedgerTable
            loading={loading}
            ledgerRows={ledgerEntries ?? []}
            paymentTable={paymentTable}
            mode={paymentTableShowMode}
            cycle={strategy?.payment_type === PaymentType.MONTHLY ? "monthly" : "weekly"}
            initialPaymentRange={strategy?.common.initial_split ?? 1}
            interestPaymentRange={strategy?.program_tenure}
          />
        </Section>
      )}
    </div>
  );
};
